// TIBECO - Program Instalare & Montaj - Calendar echipe cu Ștefan, Eusebiu, Beniamin
import React, { useState } from 'react';
import { 
  Calendar, Clock, MapPin, User, Wrench, Navigation, Phone, Eye, Edit3, 
  CheckCircle, AlertTriangle, Plus, Filter, Search, MapPin as RouteIcon, Car, Home,
  Factory, Target, Users, TrendingUp, Activity, Star, Badge as BadgeIcon
} from 'lucide-react';
import Card from '../../components/Card';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';
import { mockData } from '../../utils/mockData';

const InstallationSchedule = () => {
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [selectedWeek, setSelectedWeek] = useState(0);
  const [viewMode, setViewMode] = useState('week'); // week, day, month
  const [selectedInstallation, setSelectedInstallation] = useState(null);
  const [showInstallationModal, setShowInstallationModal] = useState(false);
  const [filterTeam, setFilterTeam] = useState('Toate echipele');

  // Echipele de instalare TIBECO
  const installationTeams = [
    {
      id: 1,
      leader: 'Ungureanu Ștefan',
      members: ['Ungureanu Ștefan'],
      specialization: 'Uși blindate și ferestre speciale',
      experience: '15+ ani',
      rating: 4.9,
      completedThisMonth: 18,
      avgTimePerInstallation: '4.2h',
      phone: '+40 731 008 008',
      status: 'Disponibil',
      currentLocation: 'TIBECO - Baza',
      equipment: ['Unelte profesionale', 'Măsurătoare laser', 'Mașină service'],
      certifications: ['Montaj ferestre', 'SSM Nivel 1', 'Uși securizate']
    },
    {
      id: 2,
      leader: 'Murariu Iulian - Eusebiu',
      members: ['Murariu Iulian - Eusebiu', 'Cojocariu Beniamin'],
      specialization: 'Ferestre PVC și aluminiu',
      experience: '12+ ani',
      rating: 4.7,
      completedThisMonth: 24,
      avgTimePerInstallation: '3.8h',
      phone: '+40 731 009 009',
      status: 'În teren',
      currentLocation: 'Str. Primăverii nr. 15',
      equipment: ['Kit montaj PVC', 'Nivela laser', 'Unelte specializate'],
      certifications: ['Montaj PVC', 'Izolație termică', 'Control calitate']
    },
    {
      id: 3,
      leader: 'Echipa Mixtă',
      members: ['Cojocariu Beniamin', 'Loghin Petrică - Ionuț'],
      specialization: 'Instalări simple și urgente',
      experience: '8+ ani',
      rating: 4.5,
      completedThisMonth: 12,
      avgTimePerInstallation: '2.5h',
      phone: '+40 721 004 004',
      status: 'Programat',
      currentLocation: 'TIBECO - Pregătire',
      equipment: ['Unelte de bază', 'Transport materiale'],
      certifications: ['Montaj standard', 'SSM de bază']
    }
  ];

  // Programări instalare pentru următoarele săptămâni
  const installationSchedule = [
    {
      id: 'INST-2024-045',
      date: '2024-09-06',
      startTime: '08:00',
      endTime: '12:00',
      duration: '4h',
      team: 'Ungureanu Ștefan',
      teamId: 1,
      client: {
        name: 'Familia Popescu',
        contact: 'Elena Popescu',
        phone: '+40 754 123 456',
        email: 'elena.popescu@gmail.com'
      },
      location: {
        address: 'Str. Libertății nr. 45, București, Sector 2',
        coordinates: '44.4268, 26.1025',
        district: 'Sector 2',
        access: 'Apartament et. 3, interfon 15, parcare în curte'
      },
      project: {
        id: 'PROJ-2024-015',
        type: 'Ferestre living + bucătărie',
        description: '3 ferestre PVC termopan, profil 5 camere',
        materials: ['Profile PVC alb', 'Sticlă termopan 24mm', 'Feronerie ROTO'],
        estimatedValue: '4,500 RON',
        complexity: 'Standard'
      },
      status: 'Confirmat',
      priority: 'Medie',
      preparationTime: '30 min',
      estimatedDuration: '3.5h',
      notes: 'Client disponibil între 08:00-12:00. Acces prin curtea blocului.',
      requirements: ['Unelte standard PVC', 'Aspirator', 'Folii protecție'],
      stage: 'Gata de instalare',
      weather: 'Înnorat, 18°C',
      previousVisits: 1,
      measurementDate: '2024-08-25'
    },
    {
      id: 'INST-2024-046',
      date: '2024-09-06',
      startTime: '09:00',
      endTime: '15:00',
      duration: '6h',
      team: 'Murariu Iulian - Eusebiu',
      teamId: 2,
      client: {
        name: 'SC Modern Build SRL',
        contact: 'Ing. Marian Gheorghe',
        phone: '+40 743 987 654',
        email: 'marian.gheorghe@modernbuild.ro'
      },
      location: {
        address: 'Șos. Colentina nr. 120, București, Sector 2',
        coordinates: '44.4685, 26.1355',
        district: 'Sector 2',
        access: 'Clădire birouri, et. 7, lift functional, parcare subterană'
      },
      project: {
        id: 'PROJ-2024-018',
        type: 'Sistem fațadă parțială',
        description: 'Instalare 8 ferestre aluminiu pentru renovare birouri',
        materials: ['Profile aluminiu anodizat', 'Sticlă low-E', 'Sisteme fixare speciale'],
        estimatedValue: '15,200 RON',
        complexity: 'Complexă'
      },
      status: 'Confirmat',
      priority: 'Ridicată',
      preparationTime: '45 min',
      estimatedDuration: '5.5h',
      notes: 'Acces cu autorizație. Coordonare cu administratorul clădirii.',
      requirements: ['Echipament înălțime', 'Unelte aluminiu', 'Sistem ridicare'],
      stage: 'În curs de instalare',
      weather: 'Înnorat, 18°C',
      previousVisits: 2,
      measurementDate: '2024-08-15'
    },
    {
      id: 'INST-2024-047',
      date: '2024-09-07',
      startTime: '08:30',
      endTime: '11:30',
      duration: '3h',
      team: 'Echipa Mixtă',
      teamId: 3,
      client: {
        name: 'Casa Verde SRL',
        contact: 'Arh. Diana Munteanu',
        phone: '+40 722 445 667',
        email: 'diana@casaverde.ro'
      },
      location: {
        address: 'Str. Parcului nr. 12, Voluntari, Ilfov',
        coordinates: '44.4956, 26.1754',
        district: 'Voluntari',
        access: 'Casă individuală, curte, parcare în față'
      },
      project: {
        id: 'PROJ-2024-016',
        type: 'Uși interior + exterior',
        description: '4 uși interior lemn + 1 ușă exterior PVC',
        materials: ['Uși lemn masiv stejar', 'Ușă PVC cu geam', 'Feronerie bronz'],
        estimatedValue: '7,800 RON',
        complexity: 'Standard'
      },
      status: 'Confirmat',
      priority: 'Medie',
      preparationTime: '20 min',
      estimatedDuration: '2.5h',
      notes: 'Casă nouă, finisaje aproape gata. Arhitecta va fi prezentă.',
      requirements: ['Unelte lemn', 'Șuruburi speciale', 'Nivele precizie'],
      stage: 'Pregătit pentru instalare',
      weather: 'Parțial înorat, 20°C',
      previousVisits: 1,
      measurementDate: '2024-08-28'
    },
    {
      id: 'INST-2024-048',
      date: '2024-09-07',
      startTime: '13:00',
      endTime: '17:00',
      duration: '4h',
      team: 'Ungureanu Ștefan',
      teamId: 1,
      client: {
        name: 'Familia Ionescu',
        contact: 'Mihai Ionescu',
        phone: '+40 766 334 221',
        email: 'mihai.ionescu@email.com'
      },
      location: {
        address: 'Bd. Unirii nr. 78, București, Sector 3',
        coordinates: '44.4267, 26.1138',
        district: 'Sector 3',
        access: 'Apartament et. 2, interfon 24, parcare stradă'
      },
      project: {
        id: 'PROJ-2024-019',
        type: 'Ferestre termopan înlocuire',
        description: '5 ferestre PVC eficiență energetică A+',
        materials: ['Profile PVC 7 camere', 'Sticlă tripan', 'Feronerie premium'],
        estimatedValue: '8,200 RON',
        complexity: 'Standard'
      },
      status: 'Reprogramat',
      priority: 'Scăzută',
      preparationTime: '25 min',
      estimatedDuration: '3.5h',
      notes: 'REPROGRAMAT din 05.09. Client a cerut amânare cu 2 zile.',
      requirements: ['Unelte PVC', 'Demontare ferestre vechi', 'Curățare'],
      stage: 'Așteptare confirmare',
      weather: 'Parțial înorat, 20°C',
      previousVisits: 0,
      measurementDate: '2024-08-30'
    },
    {
      id: 'INST-2024-049',
      date: '2024-09-08',
      startTime: '09:30',
      endTime: '13:00',
      duration: '3.5h',
      team: 'Murariu Iulian - Eusebiu',
      teamId: 2,
      client: {
        name: 'Restaurant Terasa Elite',
        contact: 'Chef Andrei Popov',
        phone: '+40 731 556 789',
        email: 'andrei@terasa-elite.ro'
      },
      location: {
        address: 'Str. Franceză nr. 45, București, Sector 1',
        coordinates: '44.4378, 26.0875',
        district: 'Sector 1',
        access: 'Restaurant, etaj 2, terasa, lift mărfuri disponibil'
      },
      project: {
        id: 'PROJ-2024-020',
        type: 'Ferestre culisante terasa',
        description: 'Sistem ferestre mobile 6x2m pentru închidere parțială terasă',
        materials: ['Profile aluminiu', 'Sticlă securizată', 'Sistem culisant automat'],
        estimatedValue: '18,000 RON',
        complexity: 'Complexă'
      },
      status: 'Confirmat',
      priority: 'Ridicată',
      preparationTime: '40 min',
      estimatedDuration: '3h',
      notes: 'Instalare pe terasă activă. Coordonare cu managementul restaurantului.',
      requirements: ['Echipament specializat', 'Sistemul de automatizare', 'Măsuri siguranță'],
      stage: 'Materiale pregătite',
      weather: 'Senin, 22°C',
      previousVisits: 1,
      measurementDate: '2024-08-20'
    }
  ];

  // Statistici instalare
  const installationStats = {
    totalScheduled: installationSchedule.length,
    todayInstallations: installationSchedule.filter(inst => inst.date === new Date().toISOString().split('T')[0]).length,
    completedThisWeek: 12,
    avgRating: 4.7,
    activeTeams: installationTeams.filter(team => team.status !== 'Indisponibil').length
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Confirmat': return 'success';
      case 'În progres': return 'primary';
      case 'Reprogramat': return 'warning';
      case 'Finalizat': return 'info';
      case 'Anulat': return 'error';
      default: return 'secondary';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'Ridicată': return 'error';
      case 'Medie': return 'warning';
      case 'Scăzută': return 'success';
      default: return 'secondary';
    }
  };

  const getComplexityIcon = (complexity) => {
    switch (complexity) {
      case 'Complexă': return '🔥';
      case 'Standard': return '🔧';
      default: return '📋';
    }
  };

  const getTeamStatusColor = (status) => {
    switch (status) {
      case 'Disponibil': return 'success';
      case 'În teren': return 'primary';
      case 'Programat': return 'warning';
      case 'Indisponibil': return 'error';
      default: return 'secondary';
    }
  };

  // Filtrare programări
  const filteredSchedule = installationSchedule.filter(installation => {
    const matchesTeam = filterTeam === 'Toate echipele' || installation.team === filterTeam;
    const matchesDate = viewMode === 'day' ? installation.date === selectedDate : true;
    return matchesTeam && matchesDate;
  });

  const formatTime = (time) => {
    return time;
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('ro-RO', { 
      weekday: 'long', 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="flex items-center gap-4">
          <Factory className="w-8 h-8 text-primary-600" />
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white flex items-center">
              <Calendar className="w-8 h-8 mr-3 text-secondary-600" />
              Program Instalare TIBECO
            </h1>
            <p className="text-gray-600 dark:text-gray-400 mt-1">
              Echipe montaj: Ștefan, Eusebiu, Beniamin • Planificare optimizată cu GPS
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-3">
          <div className="flex bg-gray-100 dark:bg-gray-800 rounded-lg p-1">
            <button 
              onClick={() => setViewMode('day')}
              className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                viewMode === 'day' 
                  ? 'bg-primary-500 text-white' 
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
              }`}
            >
              Ziua
            </button>
            <button 
              onClick={() => setViewMode('week')}
              className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                viewMode === 'week' 
                  ? 'bg-primary-500 text-white' 
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white'
              }`}
            >
              Săptămâna
            </button>
          </div>
          
          <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="form-input text-sm"
          />
          
          <button className="btn btn-primary flex items-center">
            <Plus className="w-4 h-4 mr-2" />
            Programare Nouă
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Programate</p>
              <p className="text-2xl font-bold text-gray-900 dark:text-white">{installationStats.totalScheduled}</p>
              <p className="text-sm text-gray-500">Următoarele zile</p>
            </div>
            <Calendar className="w-8 h-8 text-primary-600" />
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Astăzi</p>
              <p className="text-2xl font-bold text-blue-600">{installationStats.todayInstallations}</p>
              <p className="text-sm text-gray-500">În desfășurare</p>
            </div>
            <Clock className="w-8 h-8 text-blue-600" />
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Finalizate</p>
              <p className="text-2xl font-bold text-green-600">{installationStats.completedThisWeek}</p>
              <p className="text-sm text-gray-500">Această săptămână</p>
            </div>
            <CheckCircle className="w-8 h-8 text-green-600" />
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Rating Mediu</p>
              <p className="text-2xl font-bold text-yellow-600">{installationStats.avgRating}</p>
              <p className="text-sm text-gray-500">Satisfacție clienți</p>
            </div>
            <Star className="w-8 h-8 text-yellow-600" />
          </div>
        </Card>

        <Card>
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400">Echipe Active</p>
              <p className="text-2xl font-bold text-purple-600">{installationStats.activeTeams}</p>
              <p className="text-sm text-gray-500">Din 3 echipe</p>
            </div>
            <Users className="w-8 h-8 text-purple-600" />
          </div>
        </Card>
      </div>

      {/* Teams Overview */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <Card title="Echipe Instalare TIBECO" icon={Users}>
          <div className="space-y-4">
            {installationTeams.map((team, index) => (
              <div key={index} className="p-4 bg-gray-50 dark:bg-gray-800 rounded-xl">
                <div className="flex items-center justify-between mb-2">
                  <div>
                    <h4 className="font-medium text-gray-900 dark:text-white">{team.leader}</h4>
                    <p className="text-sm text-gray-600 dark:text-gray-400">{team.specialization}</p>
                  </div>
                  <Badge variant={getTeamStatusColor(team.status)} className="text-xs">
                    {team.status}
                  </Badge>
                </div>
                
                <div className="grid grid-cols-2 gap-4 text-sm">
                  <div>
                    <div className="flex items-center text-gray-600 dark:text-gray-400 mb-1">
                      <Star className="w-3 h-3 mr-1 text-yellow-400" />
                      Rating: {team.rating}
                    </div>
                    <div className="flex items-center text-gray-600 dark:text-gray-400">
                      <CheckCircle className="w-3 h-3 mr-1 text-green-500" />
                      {team.completedThisMonth} finalizate
                    </div>
                  </div>
                  <div>
                    <div className="flex items-center text-gray-600 dark:text-gray-400 mb-1">
                      <Clock className="w-3 h-3 mr-1" />
                      Timp mediu: {team.avgTimePerInstallation}
                    </div>
                    <div className="flex items-center text-gray-600 dark:text-gray-400">
                      <MapPin className="w-3 h-3 mr-1 text-blue-500" />
                      {team.currentLocation}
                    </div>
                  </div>
                </div>
                
                <div className="mt-3 pt-3 border-t border-gray-200 dark:border-gray-600">
                  <p className="text-xs text-gray-500 mb-1">Echipa: {team.members.join(', ')}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">{team.experience}</span>
                    <button className="text-primary-600 hover:text-primary-800 text-xs font-medium">
                      Vezi detalii
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Card>

        {/* Schedule for Selected Date */}
        <div className="lg:col-span-2">
          <Card>
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white flex items-center">
                <Calendar className="w-5 h-5 mr-2 text-secondary-600" />
                Programări {viewMode === 'day' ? formatDate(selectedDate) : 'Săptămâna'}
              </h3>
              <div className="flex items-center space-x-2">
                <select
                  value={filterTeam}
                  onChange={(e) => setFilterTeam(e.target.value)}
                  className="form-select text-sm"
                >
                  <option>Toate echipele</option>
                  {installationTeams.map(team => (
                    <option key={team.id} value={team.leader}>{team.leader}</option>
                  ))}
                </select>
                <button className="text-primary-600 hover:text-primary-700 text-sm font-medium">
                  Optimizare Rută
                </button>
              </div>
            </div>
            
            <div className="space-y-4 max-h-96 overflow-y-auto">
              {filteredSchedule.map((installation, index) => (
                <div key={index} className="p-4 bg-gray-50 dark:bg-gray-800 rounded-xl hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer"
                     onClick={() => {
                       setSelectedInstallation(installation);
                       setShowInstallationModal(true);
                     }}>
                  {/* Installation Header */}
                  <div className="flex items-start justify-between mb-3">
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="font-medium text-gray-900 dark:text-white">{installation.id}</span>
                        <span className="text-xs">{getComplexityIcon(installation.project.complexity)}</span>
                        <Badge variant={getPriorityColor(installation.priority)} className="text-xs">
                          {installation.priority}
                        </Badge>
                        <Badge variant={getStatusColor(installation.status)} className="text-xs">
                          {installation.status}
                        </Badge>
                      </div>
                      <h4 className="text-sm font-semibold text-gray-900 dark:text-white mb-1">{installation.project.type}</h4>
                      <p className="text-xs text-gray-600 dark:text-gray-400">{installation.client.name} • {installation.project.description}</p>
                    </div>
                    <div className="text-right">
                      <div className="flex items-center text-sm font-medium text-gray-900 dark:text-white mb-1">
                        <Clock className="w-4 h-4 mr-1 text-primary-600" />
                        {formatTime(installation.startTime)} - {formatTime(installation.endTime)}
                      </div>
                      <p className="text-xs text-gray-500 dark:text-gray-500">Durată: {installation.duration}</p>
                    </div>
                  </div>

                  {/* Team and Location */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                    <div className="flex items-center text-sm">
                      <User className="w-4 h-4 mr-2 text-secondary-600" />
                      <span className="font-medium text-gray-900 dark:text-white">{installation.team}</span>
                    </div>
                    <div className="flex items-start text-sm">
                      <MapPin className="w-4 h-4 mr-2 text-blue-500 mt-0.5 flex-shrink-0" />
                      <div>
                        <p className="text-gray-900 dark:text-white font-medium">{installation.location.district}</p>
                        <p className="text-xs text-gray-600 dark:text-gray-400">{installation.location.address}</p>
                      </div>
                    </div>
                  </div>

                  {/* Project Details */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3 text-xs">
                    <div>
                      <span className="font-medium text-gray-900 dark:text-white">Valoare:</span>
                      <span className="text-success font-medium ml-1">{installation.project.estimatedValue}</span>
                    </div>
                    <div>
                      <span className="font-medium text-gray-900 dark:text-white">Etapă:</span>
                      <span className="text-primary-600 ml-1">{installation.stage}</span>
                    </div>
                  </div>

                  {/* Additional Info */}
                  {installation.notes && (
                    <div className="mb-3 p-2 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg">
                      <p className="text-xs text-gray-700 dark:text-gray-300">
                        <span className="font-medium">Note:</span> {installation.notes}
                      </p>
                    </div>
                  )}

                  {/* Actions */}
                  <div className="flex items-center justify-between pt-2 border-t border-gray-200 dark:border-gray-700">
                    <div className="flex items-center space-x-3 text-xs text-gray-500 dark:text-gray-500">
                      <span>🌤️ {installation.weather}</span>
                      <span>📞 {installation.client.phone}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <button className="btn btn-sm btn-secondary">
                        <Navigation className="w-3 h-3 mr-1" />
                        GPS
                      </button>
                      <button className="btn btn-sm btn-primary">
                        <Eye className="w-3 h-3 mr-1" />
                        Detalii
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </div>
      </div>

      {/* Installation Detail Modal */}
      {selectedInstallation && (
        <Modal
          isOpen={showInstallationModal}
          onClose={() => {
            setShowInstallationModal(false);
            setSelectedInstallation(null);
          }}
          title={`${selectedInstallation.id} - ${selectedInstallation.project.type}`}
          size="xl"
        >
          <div className="space-y-6">
            {/* Header Info */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="space-y-2">
                <h4 className="font-medium text-gray-900 dark:text-white">Programare</h4>
                <div className="text-sm text-gray-600 dark:text-gray-400">
                  <div className="flex items-center mb-1">
                    <Calendar className="w-4 h-4 mr-2" />
                    {formatDate(selectedInstallation.date)}
                  </div>
                  <div className="flex items-center">
                    <Clock className="w-4 h-4 mr-2" />
                    {selectedInstallation.startTime} - {selectedInstallation.endTime}
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <h4 className="font-medium text-gray-900 dark:text-white">Status</h4>
                <div className="flex flex-col space-y-2">
                  <Badge variant={getStatusColor(selectedInstallation.status)} className="text-xs w-fit">
                    {selectedInstallation.status}
                  </Badge>
                  <Badge variant={getPriorityColor(selectedInstallation.priority)} className="text-xs w-fit">
                    Prioritate {selectedInstallation.priority}
                  </Badge>
                </div>
              </div>

              <div className="space-y-2">
                <h4 className="font-medium text-gray-900 dark:text-white">Echipa</h4>
                <div className="text-sm">
                  <p className="font-medium text-primary-600">{selectedInstallation.team}</p>
                  <p className="text-gray-600 dark:text-gray-400">
                    Experiență: {installationTeams.find(t => t.leader === selectedInstallation.team)?.experience}
                  </p>
                </div>
              </div>
            </div>

            {/* Client & Location */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h4 className="font-medium text-gray-900 dark:text-white mb-3">Informații Client</h4>
                <div className="space-y-2 text-sm">
                  <div><span className="font-medium">Nume:</span> {selectedInstallation.client.name}</div>
                  <div><span className="font-medium">Contact:</span> {selectedInstallation.client.contact}</div>
                  <div><span className="font-medium">Telefon:</span> {selectedInstallation.client.phone}</div>
                  <div><span className="font-medium">Email:</span> {selectedInstallation.client.email}</div>
                </div>
              </div>

              <div>
                <h4 className="font-medium text-gray-900 dark:text-white mb-3">Locație</h4>
                <div className="space-y-2 text-sm">
                  <div><span className="font-medium">Adresa:</span> {selectedInstallation.location.address}</div>
                  <div><span className="font-medium">Zona:</span> {selectedInstallation.location.district}</div>
                  <div><span className="font-medium">Acces:</span> {selectedInstallation.location.access}</div>
                  <div><span className="font-medium">Coordonate:</span> {selectedInstallation.location.coordinates}</div>
                </div>
              </div>
            </div>

            {/* Project Details */}
            <div>
              <h4 className="font-medium text-gray-900 dark:text-white mb-3">Detalii Proiect</h4>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-2 text-sm">
                  <div><span className="font-medium">ID Proiect:</span> {selectedInstallation.project.id}</div>
                  <div><span className="font-medium">Descriere:</span> {selectedInstallation.project.description}</div>
                  <div><span className="font-medium">Complexitate:</span> {selectedInstallation.project.complexity}</div>
                  <div><span className="font-medium">Valoare:</span> <span className="text-success font-medium">{selectedInstallation.project.estimatedValue}</span></div>
                </div>
                <div>
                  <span className="font-medium text-sm">Materiale necesare:</span>
                  <ul className="text-sm mt-1 space-y-1">
                    {selectedInstallation.project.materials.map((material, index) => (
                      <li key={index} className="flex items-center text-gray-600 dark:text-gray-400">
                        <span className="w-2 h-2 bg-primary-500 rounded-full mr-2"></span>
                        {material}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>

            {/* Requirements & Notes */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <h4 className="font-medium text-gray-900 dark:text-white mb-3">Cerințe Instalare</h4>
                <ul className="text-sm space-y-1">
                  {selectedInstallation.requirements.map((req, index) => (
                    <li key={index} className="flex items-center text-gray-600 dark:text-gray-400">
                      <CheckCircle className="w-4 h-4 text-green-500 mr-2" />
                      {req}
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h4 className="font-medium text-gray-900 dark:text-white mb-3">Informații Suplimentare</h4>
                <div className="space-y-2 text-sm">
                  <div><span className="font-medium">Pregătire:</span> {selectedInstallation.preparationTime}</div>
                  <div><span className="font-medium">Durată estimată:</span> {selectedInstallation.estimatedDuration}</div>
                  <div><span className="font-medium">Măsurători:</span> {formatDate(selectedInstallation.measurementDate)}</div>
                  <div><span className="font-medium">Vizite anterioare:</span> {selectedInstallation.previousVisits}</div>
                  <div><span className="font-medium">Vreme:</span> {selectedInstallation.weather}</div>
                </div>
              </div>
            </div>

            {selectedInstallation.notes && (
              <div className="p-4 bg-yellow-50 dark:bg-yellow-900/20 rounded-lg">
                <h4 className="font-medium text-gray-900 dark:text-white mb-2">Note importante</h4>
                <p className="text-sm text-gray-700 dark:text-gray-300">{selectedInstallation.notes}</p>
              </div>
            )}

            {/* Actions */}
            <div className="flex justify-end space-x-3 pt-4 border-t dark:border-gray-700">
              <button
                onClick={() => {
                  setShowInstallationModal(false);
                  setSelectedInstallation(null);
                }}
                className="btn btn-secondary"
              >
                Închide
              </button>
              <button className="btn btn-info">
                <Navigation className="w-4 h-4 mr-2" />
                Navigație GPS
              </button>
              <button className="btn btn-warning">
                <Edit3 className="w-4 h-4 mr-2" />
                Editează
              </button>
              <button className="btn btn-success">
                <CheckCircle className="w-4 h-4 mr-2" />
                Marchează Finalizat
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* Quick Route Optimization */}
      <Card title="Optimizare Traseu Zilnic" icon={Navigation}>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="p-4 bg-blue-50 hover:bg-blue-100 dark:bg-blue-900/30 dark:hover:bg-blue-900/50 rounded-xl transition-colors cursor-pointer">
            <RouteIcon className="w-6 h-6 text-blue-600 mb-2" />
            <h4 className="font-medium text-gray-900 dark:text-white">Traseu Ștefan</h4>
            <p className="text-sm text-gray-600 dark:text-gray-400">2 instalări • 45 km • 6.5h</p>
            <p className="text-xs text-blue-600 mt-1">Optimizare: -15 min</p>
          </div>

          <div className="p-4 bg-green-50 hover:bg-green-100 dark:bg-green-900/30 dark:hover:bg-green-900/50 rounded-xl transition-colors cursor-pointer">
            <RouteIcon className="w-6 h-6 text-green-600 mb-2" />
            <h4 className="font-medium text-gray-900 dark:text-white">Traseu Eusebiu</h4>
            <p className="text-sm text-gray-600 dark:text-gray-400">1 instalare • 28 km • 6h</p>
            <p className="text-xs text-green-600 mt-1">Traseu optimal</p>
          </div>

          <div className="p-4 bg-purple-50 hover:bg-purple-100 dark:bg-purple-900/30 dark:hover:bg-purple-900/50 rounded-xl transition-colors cursor-pointer">
            <RouteIcon className="w-6 h-6 text-purple-600 mb-2" />
            <h4 className="font-medium text-gray-900 dark:text-white">Traseu Echipa Mixtă</h4>
            <p className="text-sm text-gray-600 dark:text-gray-400">1 instalare • 18 km • 3h</p>
            <p className="text-xs text-purple-600 mt-1">Disponibil după-amiază</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default InstallationSchedule;